import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { faCheckCircle, faHeart } from "@fortawesome/free-solid-svg-icons";

import { SiteHeader } from "../../components/header/header";
import { projectData } from "../../_helpers/project-data";
import { referencesData } from "../../_helpers/references-data";
import BeforeAfterSlider from "../../components/cards/before-after";

import "../../styles/about.css";


export const AboutUs = () => {
    const navigateTo = useNavigate();
    return (
        <div className="page-body flx-col">
            <SiteHeader
                title={"Über uns"}
                navAction={() => {
                    navigateTo("/", { state: "service" })
                }}
            />
            <div className="app-body flx-col">
                <div className="upper-page">
                    <div className="service-call-container flx-rw c-al c-jt">
                        <FontAwesomeIcon icon={faCheckCircle} className="circle-check" />
                        <div className="service-text">
                            Schnellentrümpelung
                        </div>
                    </div>
                    <div className="page-title">
                        Über uns
                    </div>
                    <div className="title-context">
                        Zuverlässige Entrümpelung und Haushaltsauflösung in Berlin – schnell, diskret und fair.
                    </div>
                </div>
                <div className="about-detail">
                    <div className="detail-row">
                        <div className="detail-caption">Wer wir sind</div>
                        <div className="detail-notes">
                            <p>
                                Wir sind ein kundenfreundliches und zuverlässiges Unternehmen, gegründet 2023, und unterstützen Sie gern bei Entrümpelungen und Umzügen. Wir kümmern uns um alles – von Anfang bis Ende – damit Ihr Umzug stressfrei verläuft.
                            </p>
                        </div>
                        <div className="past-proj">
                            {referencesData.map((data, indx) => (
                                <div className="before-after-service flx-col c-al" key={indx}>
                                    <div className="flx-col c-al">
                                        <div className="data-type">{data.type}</div>
                                        <div className="city-label">{data.location}</div>
                                    </div>
                                    <BeforeAfterSlider
                                        beforeImage={data.image_before}
                                        afterImage={data.image_after}
                                    />
                                    
                                </div>
                            ))}

                            <div className="flx-col c-al c-jt sp-4">
                                <div className="cap-sub-txt">
                                    Möchten Sie auch so ein Ergebnis? Fordern Sie ein kostenloses Angebot an.
                                </div>
                                <button
                                    className="action-button prim sh-bx"
                                    onClick={() => navigateTo("/contact")}
                                >
                                    Kostenloses Angebot
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="detail-row flx-col c-al">
                        <div className="some-points flx-col">
                            <div className="detail-caption">Unsere Liestungen</div>
                            {projectData.map((datum, indx) => (
                                <div className="some-point-unit flx-rw c-al" key={indx}>
                                    <FontAwesomeIcon icon={faCheckCircle} className="circle-check" />
                                    <div className="unit-point">
                                        {datum.project}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}